// LICENSE_CODE ZON
/*jslint browser:true, es6:true, node:true, react:true*/
import React, {useState} from 'react';
import cn from 'classnames';
import etask from 'zetask';
import {Modal} from '../../../../hola/pub/lib/modal';
import {use_theme} from '../../../../hola/pub/settings_ctx';
import {Button} from '../../../../hola/pub/lib/button';
import {toolip_img_url} from '../../../../hola/pub/ui/toolip_img_url';
import {t_zone_group} from '../../../../hola/pub/ui/pro/cp/orders';
import {Checkbox} from '../../../../hola/pub/lib/checkbox';
import hola_opt from 'hola_opt';
import {Lottie} from '../../../../shared/ui/lottie';

import styles from './additional_usage_charges.module.less';

interface i_modal_props {
    is_open: boolean;
    on_close: ()=>void;
    portal?: boolean;
    group: t_zone_group;
    on_confirm: ()=>void;
}

export const use_additional_usage_charges = (props: i_modal_props)=>{
    const {group, on_close, on_confirm} = props;
    const [confirmed, set_confirmed] = useState(false);
    const [loading, set_loading] = useState(false);
    const enable_charges = ()=>{
        set_loading(true);
        etask(function*(){
            yield etask.sleep(1000);
            // XXX dmitriyr: add enable additional usage charges logic
            console.log('group: ', group);
            set_loading(false);
            on_close();
            on_confirm();
        });
    };
    const toggle_confirm = ()=>{ set_confirmed(v=>!v); };
    return {loading, enable_charges, confirmed, toggle_confirm};
};

const Btn_loader = ()=>{
    return <Lottie autoplay loop width="96" height="96"
      src={toolip_img_url('animation/toolip_loader_72_grey.json')}/>;
};

export const Usage_charges_modal = (props: i_modal_props)=>{
    const {is_open, on_close, portal, group} = props;
    const {theme} = use_theme();
    const {enable_charges, loading, confirmed,
        toggle_confirm} = use_additional_usage_charges(props);
    const modal_cls = cn(styles.usage_charges_modal, portal && styles.portal);
    const plan = hola_opt.all_plans.find(p=>p.id==group.plan_id);
    const plan_config = hola_opt.plans_config[group.plan_id];
    const per_gb = plan?.price / plan_config?.limit || 'XX';
    return <Modal is_open={is_open} on_close={on_close} portal={portal}
      cls={modal_cls} width={487} no_logo>
      <p className={cn(theme.p16, theme.med, styles.title)}>
        Need an Additional Zone?
      </p>
      <p className={cn(theme.p14, theme.med, styles.text)}>
        To add more zones, please enable "Additional Usage Charges" at an
        average of ${per_gb} per GB.
        <br/> Extra charges will appear on your next bill.
      </p>
      <div className={styles.confirm}>
        <Checkbox checked={confirmed} on_change={toggle_confirm}
          caption={'Enable Additional Usage Charges'} size="xs"
        />
      </div>
      <div className={styles.buttons}>
        <Button on_click={on_close} caption="Cancel" color="white"
          size="md" round={false}
        />
        <Button disabled={loading || !confirmed} on_click={enable_charges}
          caption={loading ? <Btn_loader/> : 'Enable Additional Usage Charges'}
          color="black" size="md" round={false} cls={styles.enable}
        />
      </div>
    </Modal>;
};
